import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { SEO } from '@/utils/seoConfig';

export default function SEOHead({ page, title, description, image, url }) {
  const location = useLocation();
  const defaults = SEO.default;
  const pageData = page ? (SEO[page] || {}) : {};

  const resolvedTitle = title || pageData.title || defaults.title;
  const resolvedDesc = description || pageData.description || defaults.description;
  const resolvedImage = image || pageData.image || defaults.image;
  const resolvedUrl = url || pageData.url || `https://digian.ai${location.pathname}`;
  const isNoIndex = pageData.noIndex || false;

  return (
    <Helmet>
      {/* Primary */}
      <title>{resolvedTitle}</title>
      <meta name="description" content={resolvedDesc} />
      <link rel="canonical" href={resolvedUrl} />
      <meta name="robots" content={isNoIndex ? 'noindex, nofollow' : 'index, follow'} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={resolvedTitle} />
      <meta property="og:description" content={resolvedDesc} />
      <meta property="og:image" content={resolvedImage} />
      <meta property="og:url" content={resolvedUrl} />
      <meta property="og:site_name" content="Digian" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={resolvedTitle} />
      <meta name="twitter:description" content={resolvedDesc} />
      <meta name="twitter:image" content={resolvedImage} />
    </Helmet>
  );
}
